import { SubscriptionPlanCategoryEnum } from "src/utils/enums/PartnerSubscription";
import { SubscriptionPlanInterface } from "src/utils/interfaces/payment/SubscrptionPlanInterface";

/** Custom enterprise card id (not from API). */
export const ND_CUSTOM_PLAN_ID = "ndCust";

export type NationalDayPlanId = string;

export const NATIONAL_DAY_JOB_DURATION_DAYS = 30;
export const NATIONAL_DAY_VALIDITY_MONTHS = 12;

/** Campaign is visible through end of 30 September 2026 (KSA). Hidden from 1 October 2026. */
export const NATIONAL_DAY_OFFER_END = new Date("2026-10-01T00:00:00+03:00");

export const isNationalDayOfferActive = () => new Date() < NATIONAL_DAY_OFFER_END;

/** Exclusive yearly bundles are purchased as a single fixed package. */
export const EXCLUSIVE_PLAN_JOBS_COUNT = 1;

export const sortExclusivePlans = (plans: SubscriptionPlanInterface[] = []) => {
    const order = [SubscriptionPlanCategoryEnum.CORE, SubscriptionPlanCategoryEnum.RISE];
    return [...plans].sort(
        (a, b) => order.indexOf(a.category) - order.indexOf(b.category)
    );
};

export const getDefaultExclusivePlanId = (plans: SubscriptionPlanInterface[]): string | null => {
    const sorted = sortExclusivePlans(plans);
    const premium = sorted.find((p) => p.category === SubscriptionPlanCategoryEnum.RISE);
    return premium?.externalId || sorted[0]?.externalId || null;
};

export const getExclusivePlanNameKey = (category?: SubscriptionPlanCategoryEnum) => {
    if (category === SubscriptionPlanCategoryEnum.CORE) return "pricing_v2_nd_plan_basic";
    if (category === SubscriptionPlanCategoryEnum.RISE) return "pricing_v2_nd_plan_premium";
    return `plan_v2_${category}`;
};

export const getExclusivePlanJobPosts = (plan: SubscriptionPlanInterface) =>
    plan.jobsPerResetCycle || 1;

/**
 * Exclusive plans return package totals in `unlocksPerResetCycle` (e.g. 300 / 600),
 * unlike regular plans where that field is per-job and must be multiplied by jobs.
 */
export const getExclusivePlanContacts = (plan: SubscriptionPlanInterface) =>
    plan.unlocksPerResetCycle || 0;

export const getExclusivePlanContactsPerJob = (plan: SubscriptionPlanInterface) => {
    const jobPosts = getExclusivePlanJobPosts(plan);
    const total = getExclusivePlanContacts(plan);
    return jobPosts > 0 ? Math.round(total / jobPosts) : total;
};

export const getExclusivePlanPerAd = (plan: SubscriptionPlanInterface, subtotal: number) => {
    const jobPosts = getExclusivePlanJobPosts(plan);
    return jobPosts > 0 ? Math.round(subtotal / jobPosts) : subtotal;
};

export const findSubscriptionPlanById = (
    planId: string,
    subscriptionPlans: SubscriptionPlanInterface[] = [],
    exclusivePlans: SubscriptionPlanInterface[] = []
): SubscriptionPlanInterface | undefined =>
    exclusivePlans.find((p) => p.externalId === planId) ||
    subscriptionPlans.find((p) => p.externalId === planId);
